import Link from "next/link";
import { ReactElement } from "react"
import { withAuth } from "@jconradi/tutu-porn-components/components/Auth/AuthGuard";
import { getLayout } from "../Layout";
import styles from './UserSettingsLayout.module.css';
import cn from 'clsx';
import { useRouter } from "next/router";
import useTranslation from "next-translate/useTranslation";

export interface LayoutProps {
    children: ReactElement[] | ReactElement;
}
export const UserSettingsLayout = ({ children }: LayoutProps) => {
    const { t } = useTranslation('settings');
    return (
        <div className="flex flex-col sm:flex-row w-full items-start gap-y-4">
            <menu className="border border-outline bg-base-300 rounded-2xl shadow-xl
             w-full p-4 md:pr-16 w-full sm:w-[170px] md:w-[262px] flex flex-col font-bold">
                <ListLink href="/user/profile">{t('menu.profile')}</ListLink>
                {/* <ListLink href="/user/settings">Account Info</ListLink> */}
            </menu>
            {children}
        </div>
    )
}

const ListLink = ({ href, children }: any) => {
    const router = useRouter();
    const linkStyles = cn(styles.link, {
        [styles.active]: href === router.asPath
    });
    return (
        <Link className={linkStyles} href={href}>{children}</Link>
    )
}

export const getUserSettingsLayout = (page: ReactElement | ReactElement[]) => {
    return getLayout(withAuth(<UserSettingsLayout>
        {page}
    </UserSettingsLayout>))
}